<button matButton
        [matMenuTriggerFor]="profileMenu"
        [attr.aria-label]="'Account menu for ' + viewState().displayName">
    <span class="flex items-center gap-2">
        <span class="hidden max-w-40 truncate text-lg sm:block">{{viewState().displayName}}</span>
        @if (viewState().profileImageSrc) {
            <img class="h-8 w-8 shrink-0 rounded-full object-cover"
                 [src]="viewState().profileImageSrc"
                 alt="" />
        } @else {
            <mat-icon aria-hidden="true">account_circle</mat-icon>
        }
        <mat-icon aria-hidden="true">expand_more</mat-icon>
    </span>
</button>

<mat-menu #profileMenu="matMenu" xPosition="before">
    <a mat-menu-item routerLink="/account">
        <mat-icon>credit_card</mat-icon>
        <span class="avatar-menu-label">Plan & Billing</span>
    </a>
    <a mat-menu-item routerLink="/profile/edit">
        <mat-icon>edit</mat-icon>
        <span class="avatar-menu-label">Edit Profile</span>
    </a>
    <a mat-menu-item routerLink="/settings">
        <mat-icon>settings</mat-icon>
        <span class="avatar-menu-label">Settings</span>
    </a>
    <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span class="avatar-menu-label">Log Out</span>
    </button>
</mat-menu>
